import React from 'react';
import PropTypes from 'prop-types';
import Select from '@tds/core-select';

const SelectFilter = ({
  label,
  placeholder,
  options,
  value,
  onChange,
  defaultValue,
  disabled
}) => {
  return options && (
    <Select
      label={label}
      placeholder={placeholder}
      options={options}
      defaultValue={defaultValue}
      value={value}
      onChange={onChange}
      disabled={disabled}
    />
  );
};

SelectFilter.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  value: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

SelectFilter.defaultProps = {
  defaultValue: '',
  disabled: false
};

export default SelectFilter;
